import React from 'react';
import { Provider } from 'react-redux';
import ManageScoreRoutes from './ManageScoreRoutes';
import { InjectorProvider } from "../../angularReactRedux/InjectorProvider";
import { hot } from 'react-hot-loader'
import {reduxStore} from "../../angularReactRedux/reduxStore";
import scoresModule from "../scores-module";

// TODO - this isn't working for hot module replacing :(
// it does for the social tab though
const Hot = hot(module)(({ store, $injector }) => {
  return <Provider store={reduxStore}>
    <InjectorProvider $injector={$injector}>
      <ManageScoreRoutes />
    </InjectorProvider>
  </Provider>
})

scoresModule.value('RenderSocialScoreSettingsReact', ({ store, $injector }) => {
  return <Hot store={store} $injector={$injector} />
});

scoresModule
  .controller("ManageScoreCtrl",
    ($scope, $injector, scoreSetActions) => {

    scoreSetActions.initData()
    $scope.props = {
      $injector
    };
});


